// extracted by extract-css-chunks-webpack-plugin
module.exports = {"ClippedContent":"ClippedContent_3ZqOF_v13-0-0","ClippedContent__AlignX":"ClippedContent__AlignX_1sG4k_v13-0-0","ClippedContent__AlignY":"ClippedContent__AlignY_13yd5_v13-0-0","ClippedContent__FullHeight":"ClippedContent__FullHeight_3xlgl_v13-0-0","ClippedContent__FullWidth":"ClippedContent__FullWidth_2WqZo_v13-0-0","ClippedContent__ShapeCircle":"ClippedContent__ShapeCircle_2jpXo_v13-0-0"};
    if(module.hot) {
      // 1588357788366
      var cssReload = require("../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  